// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Contenedor Principal de la Sección ===== */
.Garantia_guaranteeSection__4gCoI {
  background-color: #121212; /* Un negro ligeramente más suave */
  padding: 60px 5%;
}

.Garantia_container__bKC80 {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  gap: 40px;
}

/* ===== Estilo de cada Item de Garantía ===== */
.Garantia_guaranteeItem__qe3Py {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1; /* Ocupa el espacio disponible */
}

.Garantia_iconWrapper__OrgHv {
  margin-bottom: 20px;
  color: #FF3B00;
}

.Garantia_iconWrapper__OrgHv svg {
  width: 50px;
  height: 50px;
  color: #FF3B00;
}

.Garantia_guaranteeItem__qe3Py h3 {
  font-size: 24px;
  font-weight: 700;
  color: var(--textoBlanco);
  margin-bottom: 10px;
}

.Garantia_guaranteeItem__qe3Py p {
  font-size: 16px;
  color: #c7c7c7;
  line-height: 1.6;
  max-width: 350px; /* Evita que el texto se estire demasiado */
}

/* ======================================= */
/* ===== MEDIA QUERY PARA MÓVILES ===== */
/* ======================================= */
@media (max-width: 767px) {
  .Garantia_container__bKC80 {
    flex-direction: column; /* Apila los elementos verticalmente */
    gap: 50px;
  }
  .Garantia_guaranteeItem__qe3Py h3 {
    font-size: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Garantia.module.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,yBAAyB,EAAE,mCAAmC;EAC9D,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,SAAS;AACX;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO,EAAE,gCAAgC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA,4CAA4C;AAC5C,yCAAyC;AACzC,4CAA4C;AAC5C;EACE;IACE,sBAAsB,EAAE,sCAAsC;IAC9D,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ===== Contenedor Principal de la Sección ===== */\n.guaranteeSection {\n  background-color: #121212; /* Un negro ligeramente más suave */\n  padding: 60px 5%;\n}\n\n.container {\n  max-width: 900px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-around;\n  gap: 40px;\n}\n\n/* ===== Estilo de cada Item de Garantía ===== */\n.guaranteeItem {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1; /* Ocupa el espacio disponible */\n}\n\n.iconWrapper {\n  margin-bottom: 20px;\n  color: #FF3B00;\n}\n\n.iconWrapper svg {\n  width: 50px;\n  height: 50px;\n  color: #FF3B00;\n}\n\n.guaranteeItem h3 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--textoBlanco);\n  margin-bottom: 10px;\n}\n\n.guaranteeItem p {\n  font-size: 16px;\n  color: #c7c7c7;\n  line-height: 1.6;\n  max-width: 350px; /* Evita que el texto se estire demasiado */\n}\n\n/* ======================================= */\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n/* ======================================= */\n@media (max-width: 767px) {\n  .container {\n    flex-direction: column; /* Apila los elementos verticalmente */\n    gap: 50px;\n  }\n  .guaranteeItem h3 {\n    font-size: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guaranteeSection": `Garantia_guaranteeSection__4gCoI`,
	"container": `Garantia_container__bKC80`,
	"guaranteeItem": `Garantia_guaranteeItem__qe3Py`,
	"iconWrapper": `Garantia_iconWrapper__OrgHv`
};
export default ___CSS_LOADER_EXPORT___;
